import { useEffect, useRef } from 'react';

const TURNSTILE_SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
export const TURNSTILE_SITE_KEY = import.meta.env.REACT_APP_TURNSTILE_SITE_KEY;

let scriptPromise;
const loadTurnstile = () => {
  scriptPromise ??= new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = TURNSTILE_SCRIPT_URL;
    script.async = true;
    script.onload = () => resolve(window.turnstile);
    script.onerror = () => {
      scriptPromise = undefined;
      reject(new Error('Could not load the verification challenge.'));
    };
    document.head.appendChild(script);
  });
  return scriptPromise;
};

const TurnstileWidget = ({ onToken }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!TURNSTILE_SITE_KEY) return undefined;
    let widgetId;
    let cancelled = false;
    loadTurnstile().then((turnstile) => {
      if (cancelled) return;
      widgetId = turnstile.render(containerRef.current, {
        sitekey: TURNSTILE_SITE_KEY,
        callback: onToken,
        'expired-callback': () => onToken(null),
        'error-callback': () => onToken(null),
      });
    }).catch((error) => console.error('Turnstile failed to load:', error));
    return () => {
      cancelled = true;
      if (widgetId !== undefined) window.turnstile?.remove(widgetId);
    };
  }, [onToken]);

  return TURNSTILE_SITE_KEY ? <div ref={containerRef} className="auth-turnstile" /> : null;
};

export default TurnstileWidget;
